<template>
  <!-- new design  -->
   <el-container class="form-container" >
    <el-aside 
      v-show="uploadProgress === UploadProgress.Select"
      v-bind="$attrs" 
      :class="['sidemenu', { expanded: isSidemenu }, $attrs.class]"
    >
      <!-- Form indicator  -->
      <step-line-indicator 
        :currentStep="currentStep + 1" 
        :steps="steps"
        @change-step="(index: number) => currentStep = index - 1"
      />
      <!-- Form indicator end -->

      <!-- Step 1 - Required field for upload product  -->
      <el-scrollbar v-show="currentStep === 0" class="step-view">
        <el-form class="step-content" ref="dataForm" :model="loadingData" label-position="top" status-icon>
          <el-form-item v-if="referenceData && referenceData.length > 0" prop="referenceCategory" :label="$t('components.mesh-loader.reference-category')">
            <el-select v-model="loadingData.referenceCategory">
              <el-option v-for="category in Object.values(UploadCategory)" :key="category" :value="category" :label="$t(`enum.upload-category.${category}`)" />
            </el-select>
          </el-form-item>
          
          <el-form-item v-if="referenceData && referenceData.length > 0" prop="reference" :label="$t('components.mesh-loader.reference')">
            <el-select v-model="loadingData.referenceId">
              <el-option v-for="reference in categoryReferences" :key="reference" :value="reference.uniqueKey" :label="reference.name" />
            </el-select>
          </el-form-item>

          <!-- Category Form -->
          <el-form-item prop="category" :label="$t('components.mesh-loader.category')">
            <el-select v-model="loadingData.category">
              <el-option v-for="category in Object.values(UploadCategory)" :key="category" :value="category" :label="$t(`enum.upload-category.${category}`)" />
            </el-select>
          </el-form-item>

          <!-- ProductType Form -->
          <el-form-item v-if="isProductCategory" prop="productType" :label="$t('components.mesh-loader.producttype')">
            <el-select v-model="loadingData.productType" :disabled="isFetchingProductTypeList" @change="logProductType">
              <el-option v-for="productType in productTypeList" :key="productType.productTypeId" :value="productType.name" :label="$t(`enum.product-type.${productType.name}`)" />
            </el-select>
          </el-form-item>

          <!-- Properties Form -->
          <el-form-item v-if="isProductCategory && isProductType" prop="productTypeAttribute" :label="$t('components.mesh-loader.productTypeAttribute')" 
            :rules="{
              required: false,
              message: $t('error.vuelidate.required'),
              trigger: 'blur',
            }">
            <el-select v-model="loadingData.productTypeAttributeId" :disabled="isFetchingProductTypeList || filteredProductTypeAttributes.length === 0" placeholder="Select">
              <el-option v-for="attribute in filteredProductTypeAttributes" :key="attribute.productTypeAttributeId" :value="attribute.productTypeAttributeId" :label="$t(`enum.productTypeAttributes.${attribute.productTypeAttributeName.toLowerCase()}`)" />
            </el-select>
          </el-form-item>

          <!-- domain Packages Form -->
          <el-form-item 
            prop="domainPackages" 
            :label="$t('components.mesh-loader.packageOptionLabel')"
            :rules="{
              required: true,
              message: $t('error.vuelidate.required'),
              trigger: 'blur',
            }"
          >
            <MultiCheckboxSelect
              v-model="loadingData.packageIds"
              :subLabel="$t('components.mesh-loader.packageOptionDescription')"
              :disabledInfo="$t('components.mesh-loader.packageOptionDisabledInfo')"
              :options="domainPackages"
              :validateError="userFeedback.packageShowValidateError"
              @change="handleDomainPackagesChange"
            />
          </el-form-item>

          <!-- Mesh Name -->
          <el-form-item
            prop="title"
            :label="$t('components.mesh-loader.title')"
            :rules="{
              required: true,
              message: $t('error.vuelidate.required'),
              trigger: 'blur',
            }"
          >
            <el-input v-model="loadingData.title" />
          </el-form-item>

          <!-- Mesh Description -->
          <el-form-item
            prop="description"
            :label="$t('components.mesh-loader.description')"
            :rules="{
              required: true,
              message: $t('error.vuelidate.required'),
              trigger: 'blur',
            }"
          >
            <el-input v-model="loadingData.description" :rows="2" type="textarea" />
          </el-form-item>

          <!-- Country / Price -->
          <el-button class="mb-3" type="primary" :disabled="isFetchingCountries" @click="dialogVisible = true">
            {{ $t('components.mesh-loader.priceCountryBtn') }}
          </el-button>

          <!-- Upload 3D Object  -->
          <el-form-item
            prop="url"
            :label="$t('components.mesh-loader.mesh')"
            :rules="{
              required: true,
              message: $t('error.vuelidate.required'),
              trigger: 'blur',
            }"
          >
           <ObjectUploadList
              :desription="$t('components.mesh-loader.meshFilesSubTitle')"
              :mesh-files="meshFiles"
              :before-upload="beforeUpload"
              :upload-file="uploadFile"
              :get-file-type="getFileType"
              :handle-remove="handleRemove"
              :template-upload-image-type="TemplateUploadImageType"
              :validateError="userFeedback.meshShowValidateError"
              @update:meshFiles="meshFiles = $event"
              @update:selectedUids="handleMultipleRemove"
            />
          </el-form-item>

          <!-- Upload Product Image  -->
          <el-form-item
            :label="$t('components.mesh-loader.thumbnail')"
            :rules="{
              required: true,
              message: $t('error.vuelidate.required'),
              trigger: 'blur',
            }"
          >
            <ImageUploadList
              class="upload-list-dialog"
              v-model="productImageFiles"
              :multiple="true"
              :disabled="true"
              accept=".jpg,.jpeg,.png"
              :drag="true"
              :label="$t('components.mesh-loader.thumbnail')"
              :type="TemplateUploadImageType.product"
              :description="$t('components.mesh-loader.imageUploadSubTitle')"
              :validateError="userFeedback.imageShowValidateError"
              :before-upload="beforeImageUpload"
              :http-request="uploadFile"
              :handle-remove="(file: UploadFile, type: TemplateUploadImageType) => handleRemove(file, type)"
              :handle-click="(e: MouseEvent) => handleUploadAssetClick({
                event:e,
                tab:'product'
              })"
            />
          </el-form-item>

        </el-form>
      </el-scrollbar>
      <!-- Step 1 - end  -->

      <!-- Step 2 - Option field for upload product image, engraving, texture and video  -->
      <el-scrollbar v-show="currentStep === 1" class="step-view">
        <el-form class="step-content" ref="dataForm" :model="loadingData" label-position="top" status-icon>
          <!-- Upload Engraving Image  -->
          <div id="engraving-upload-area">
            <el-form-item
              :label="$t(`components.mesh-loader.engraving`)"
              :rules="{
                required: this.engravingImageFilesHR.length !== this.engravingImageFilesLR.length,
                message: $t('error.vuelidate.required'),
                trigger: 'blur',
              }"
            >
              <div class="list-box-upload">
                <!-- hide temporarily  -->
                <ImageUploadListV2
                  :disabled="true"
                  v-if="false"
                  class="upload-list-dialog"
                  v-model:file-list="engravingImageFilesLR"
                  :multiple="true"
                  :accept="'.jpg,.jpeg,.png'"
                  :label="$t(`components.mesh-loader.engraving`)"
                  :type="TemplateUploadImageType.engravingLR"
                  :before-upload="beforeImageUpload"
                  :http-request="uploadFile"
                  :handle-remove="(file: UploadFile, type: TemplateUploadImageType) => handleRemove(file, type)"
                  :handle-click="(e: MouseEvent) => handleUploadAssetClick({
                    event:e,
                    tab:'engraving'
                  })"
                  :sub-title="$t(`components.mesh-loader.engravingLR`)"
                />

                <ImageUploadListV2  
                  :disabled="true"
                  class="upload-list-dialog"
                  :file-list="selectedEngravingitems"
                  :multiple="true"
                  accept=".jpg,.jpeg,.png"
                  :drag="true"
                  :label="$t(`components.mesh-loader.engraving`)"
                  :type="TemplateUploadImageType.engravingHR"
                  :before-upload="beforeImageUpload"
                  :http-request="uploadFile"
                  :handle-remove="(file: UploadFile, type: TemplateUploadImageType) => handleRemove(file, type)"
                  :handle-click="(e: MouseEvent) => handleUploadAssetClick({
                    event:e,
                    tab:'engraving'
                  })"
                  :sub-title="`${$t(`components.mesh-loader.engravingSelected`)} (${selectedEngravingitems.length} items)`"
                  :isPreview="false"
                />

                <ImageUploadListV2
                  :disabled="true"
                  class="upload-list-dialog"
                  v-model:file-list="engravingImageFilesHR"
                  :multiple="true"
                  accept=".jpg,.jpeg,.png"
                  :drag="true"
                  :label="$t(`components.mesh-loader.engraving`)"
                  :type="TemplateUploadImageType.engravingHR"
                  :before-upload="beforeImageUpload"
                  :http-request="uploadFile"
                  :handle-remove="(file: UploadFile, type: TemplateUploadImageType) => handleRemove(file, type)"
                  :handle-click="(e: MouseEvent) => handleUploadAssetClick({
                    event:e,
                    tab:'engraving'
                  })"
                  :sub-title="$t(`components.mesh-loader.engravingHR`)"
                />

              </div>
            </el-form-item>
            
            <!-- <p v-if="this.engravingImageFilesHR.length !== this.engravingImageFilesLR.length " class="text-danger text-sm">{{ $t(`error.vuelidate.imageLengthNotMatch`) }}</p> -->
          </div>

            <!-- Upload Texture Image  -->
          <div id="texture-upload-area">
            <el-form-item
              :label="$t(`components.mesh-loader.texture`)"
              :rules="{
                required: this.textureImageFilesLR.length !== this.textureImageFilesHR.length,
                message: $t('error.vuelidate.required'),
                trigger: 'blur',
              }"
            >
              <div class="list-box-upload">
                <!-- hide temporarily  -->
                <ImageUploadListV2
                  :disabled="true"
                  class="upload-list-dialog"
                  v-if="false"
                  v-model:file-list="textureImageFilesLR"
                  :multiple="true"
                  accept=".jpg,.jpeg,.png"
                  :drag="true"
                  :label="$t(`components.mesh-loader.texture`)"
                  :type="TemplateUploadImageType.textureLR"
                  :before-upload="beforeImageUpload"
                  :http-request="uploadFile"
                  :handle-remove="(file: UploadFile, type: TemplateUploadImageType) => handleRemove(file, type)"
                  :handle-click="(e: MouseEvent) => handleUploadAssetClick({
                    event:e,
                    tab:'texture'
                  })"
                  :sub-title="$t(`components.mesh-loader.textureLR`)"
                />
                <ImageUploadListV2
                  :disabled="true"
                  class="upload-list-dialog"
                  :file-list="selectedTexturesitems"
                  :multiple="true"
                  accept=".jpg,.jpeg,.png"
                  :drag="true"
                  :label="$t(`components.mesh-loader.texture`)"
                  :type="TemplateUploadImageType.textureHR"
                  :before-upload="beforeImageUpload"
                  :http-request="uploadFile"
                  :handle-remove="(file: UploadFile, type: TemplateUploadImageType) => handleRemove(file, type)"
                  :handle-click="(e: MouseEvent) => handleUploadAssetClick({
                    event:e,
                    tab:'texture'
                  })"
                  :sub-title="`${$t(`components.mesh-loader.textureSelected`)} (${selectedTexturesitems.length} items)`"
                  :isPreview="false"
                />

                <ImageUploadListV2
                  :disabled="true"
                  class="upload-list-dialog"
                  v-model:file-list="textureImageFilesHR"
                  :multiple="true"
                  accept=".jpg,.jpeg,.png"
                  :drag="true"
                  :label="$t(`components.mesh-loader.texture`)"
                  :type="TemplateUploadImageType.textureHR"
                  :before-upload="beforeImageUpload"
                  :http-request="uploadFile"
                  :handle-remove="(file: UploadFile, type: TemplateUploadImageType) => handleRemove(file, type)"
                  :handle-click="(e: MouseEvent) => handleUploadAssetClick({
                    event:e,
                    tab:'texture'
                  })"
                  :sub-title="$t(`components.mesh-loader.textureHR`)"
                />

              </div>
              <!-- <div class="text-sm text-danger" v-if="!isValidationTextureImageSize">File size exceeds the limit!</div> -->
            </el-form-item>
            <!-- <p v-if="this.textureImageFilesLR.length !== this.textureImageFilesHR.length " class="text-danger text-sm">{{ $t(`error.vuelidate.imageLengthNotMatch`) }}</p> -->
          </div>

              <!-- Upload Engraving Image  -->
          <div id="color-upload-area">
            <el-form-item
              :label="$t(`components.mesh-loader.color`)"
            >
              <div class="list-box-upload">
                <div class="color-gallery"
                @click="(e: MouseEvent) => handleUploadAssetClick({
                  event:e,
                  tab:'color'
                })"
                >
                  <p v-if="selectedColors.length === 0">-{{ $t(`components.mesh-loader.no-selected`) }}-</p>
                  <div 
                    class="color-item"
                    v-for="color in selectedColors" :key="color.name">
                    <div 
                    class="color" 
                    :style="{
                      background: `rgb(${color.red},${color.green},${color.blue},${color.alpha || 1})`
                      }">
                    </div>
                    <p class="mb-0">{{ safeT({t:$t, category:'colors', keyName:color.name}) }}</p>
                  </div>
                </div>
              </div>
            </el-form-item>
          </div>
  
          <!-- Upload Product Video  -->
          <el-form-item
            v-if="false"
            prop="videoUrl"
            :label="$t('components.mesh-loader.video')"
          >
            <el-upload
              v-model:file-list="productVideoFiles"
              multiple
              action="#"
              drag
              list-type="picture-card"
              :before-upload="beforeVideoUpload"
              :http-request="(res: any) => uploadFile(res, TemplateUploadImageType.video)"
              accept=".mp4,.webm,.mov,.mkv,.avi"
              class="upload-video"
            >
              <template #default>
                <div>
                  <font-awesome-icon icon="upload" class="primary" size="xl" />
                  <div class="text-sm text-center">
                    {{ $t('components.mesh-loader.video') }}
                  </div>
                </div>
              </template>
              <template #file="{ file }">
                <PreviewRendererVideo
                  :meshes="[
                    {
                      videoFiletype: getVideoFileType(file.name),
                      video: selectedInput.video,
                      videoUrl: selectedInput.videoUrl,
                      videoThumbnailFiletype: selectedInput.videoThumbnailFiletype,
                      videoThumbnail: selectedInput.videoThumbnail,
                      videoThumbnailUrl: selectedInput.videoThumbnailUrl,
                    },
                  ]"
                  :can-remove="false"
                  :can-play="true"
                  :is-loading="uploadVideoLoading"
                  @remove-item="handleRemove(file, TemplateUploadImageType.video)"
                />
              </template>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-scrollbar>
      <!-- Step 1 - end  -->

      <!-- Hide this feature since the flow is not quite clear -->
      <el-scrollbar v-show="false" class="step-view">
        <el-form class="step-content" ref="dataForm" :model="loadingData" label-position="top" status-icon>
          <el-form-item prop="configuration" :label="'Product Config Form'" class="fw-bold">
            <div class="alert alert-light mb-3 lh-base py-2 px-3 fw-normal" role="alert">
              You can create dynamic custom forms for your product configuration.
            </div>
            <el-button type="primary" @click="setShowFormBuilder()">
              {{ productConfigButtonText }}
            </el-button>
          </el-form-item>
        </el-form>
      </el-scrollbar>

      <!-- Button Stepper  -->
      <div class="sidemenu-footer">
        <el-button type="primary" class="btn-stepper" v-show="setIndicatorStep('previous')" @click="goToPrevious">
          {{ $t('views.configurator.previous') }}
        </el-button>
        <!-- <el-button type="primary" class="btn-stepper" v-show="setIndicatorStep('next')" @click="goToNext" :disabled="!validateNextStep"> -->
        <el-button type="primary" class="btn-stepper" v-show="setIndicatorStep('next')" @click="goToNext">
          {{ $t('views.configurator.next') }}
        </el-button>
      </div>
      <!-- Button Stepper  end-->
    </el-aside>
    <!-- Select mesh section end -->

    <!-- Set marking points section  -->
    <el-aside
      v-if="uploadProgress === UploadProgress.Pivot"
      v-bind="$attrs" 
      :class="['sidemenu', { expanded: isSidemenu }, $attrs.class]"
    >
      <div class="step-view">
        <div class="py-3">
          <p class="title">Set Marking Points</p>
        </div>
        <el-scrollbar>
          <el-steps :key="boneKey" direction="vertical" :active="activeBoneIndex">
            <draggable v-model="boneData" handle=".el-step__icon" item-key="id" @end="dragDone">
              <template #item="{ element, index }">
                <el-step @click="activeBoneIndex = index">
                  <template #title>
                    <span class="media">
                      <el-input v-model="element.name" class="media-content" :placeholder="$t('components.mesh-loader.boneName')" />
                      <span v-if="boneData.length > 2" class="action media-right" @click="removeBone(index)">
                        <font-awesome-icon icon="trash" />
                      </span>
                    </span>
                  </template>
                </el-step>
              </template>
            </draggable>
          </el-steps>
        </el-scrollbar>
        <div class="addButton">
          <el-button type="primary" circle @click="addBone(null)">
            <font-awesome-icon icon="plus" />
          </el-button>
        </div>
      </div>
    </el-aside>
    <!-- Set marking points section end  -->
    
    <!-- Toggle Button -->
    <button v-if="uploadProgress !== UploadProgress.Orientation" class="collapse-btn" type="button" @click="toggleSidemenu">
      <el-icon :size="13" style="margin-top: 5px">
        <ArrowRightBold v-if="!isSidemenu" />
        <ArrowLeftBold v-else />
      </el-icon>
    </button>
    <!-- Toggle Button end-->

    <!-- Mesh Editor  -->
    <el-main>
      <div class="flex-grow-1 main-content" style="height: 93vh; overflow: hidden; margin-left: -1.8rem; position: relative;">
        <MeshEditor
          ref="meshEditor"
          v-model="selectedInput"
          :can-toggle-pivot-mode="false"
          :can-select="canSelect"
          :can-toggle-bones="false"
          :can-undo="uploadProgress !== UploadProgress.Select"
          :can-deform="false"
          :can-curve="false"
          :can-resolution="false"
          :can-toggle-opacity="canToggleOpacity"
          :activate-aline-to-floor="true"
          :activate-bones="uploadProgress === UploadProgress.Pivot"
          :active-editor-mode="activeEditorMode"
          :active-modify-type="uploadProgress === UploadProgress.Orientation ? ModifyType.rotate : ModifyType.translate"
          :reset-on-pivot-changed="true"
          :fit-camera-to-scene="true"
          :default-orientation-axis="uploadProgress === UploadProgress.Orientation ? OrientationAxis.y : OrientationAxis.none"
          :can-take-snapshot="canTakeSnapshot"
          :has-toolbar="true"
          :fullscreen="false"
          :show-orientation-gizmo="true"
          @take-snapshot="takeSnapshot"
          @selection-changed="selectionChanged"
          @get-mesh-sizes="handleGetMeshSizes"
        />
      </div>
      <div v-bind="$attrs" :class="['workflow-section', { expanded: !isSidemenu }, $attrs.class]">
        <Workflow 
          class="workflow" 
          :workflow-model="workflowModel" 
          :fullscreen-loading="fullscreenLoading" 
          :disabledNext="!selectMeshStepValid"
          :tooltipMessage="missingFields"
        />
      </div>
    </el-main>
    <!-- Mesh Editor end -->

  </el-container>

  <!-- Modal for upload image  -->
  <UploadAssetsModal
    v-model:productImageFiles="productImageFiles"
    
    v-model:engravingImageFilesHR="engravingImageFilesHR"
    v-model:engravingImageFilesLR="engravingImageFilesLR"
    v-model:selectedEngravingImagesLR="selectedEngravingImagesLR"
    v-model:selectedEngravingImagesHR="selectedEngravingImagesHR"
    
    v-model:textureImageFilesHR="textureImageFilesHR"
    v-model:textureImageFilesLR="textureImageFilesLR"
    v-model:selectedTextureImagesLR="selectedTextureImagesLR"
    v-model:selectedTextureImagesHR="selectedTextureImagesHR"

    v-model:selectedColors="selectedColors"
    v-model:activeTab="defaultAssetModalTab"

    v-model:selectedEngraving="selectedEngraving"
    v-model:selectedTextures="selectedTextures"

    :idDialog="'upload-assets-dialog'"
    :dialog="uploadAssetsDialog"
    :loadingData="loadingData"
    :meshColors="meshColors"
    :meshEngravings="meshEngravings"
    :meshEngravingsLoading="meshEngravingsLoading"
    :meshTexture="meshTextures"
    :meshTexturesLoading="meshTexturesLoading"
    :before-image-upload="beforeImageUpload"
    :max-filesize-upload="maxFileSizeMB"
    @uploadFile="uploadFile"
    @getImageFileType="getImageFileType"
    @handleRemove="handleRemove"
    @handleRemoveSelectedImage="handleRemoveSelectedImage"
  />
  <!-- Modal for upload image end -->

  <el-dialog
    v-model="dialogVisible"
    :title="$t('components.mesh-loader.priceCountryTitle')"
    :show-close="false"
    style="width: fit-content; max-width: 50%; top: 5rem"
  >
    <el-table :data="loadingData.basePrices" :table-layout="'auto'">
    <el-table-column :label="$t('components.mesh-loader.country')" width="150">
      <template #default="{ row }">
        {{ row.country ? $t(`enum.countries.${row.country}`) : '-' }}
      </template>
    </el-table-column>
      <el-table-column prop="price" :label="$t('components.mesh-loader.price')" width="200">
        <template #default="scope">
          <el-input
            v-model="scope.row.price"
            class="p-2"
            :formatter="(value: unknown) => {
              if (value === null || value === undefined || value === '') return '';

              const num = Number(
                String(value)
                  .replace(/[^\d,-.]/g, '')
                  .replace(',', '.')
              );

              if (isNaN(num)) return '';

              return `€ ${num.toLocaleString('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}`;
            }"
            :parser="(value: string) => {
              if (!value) return null;

              const normalized = value
                .replace(/[€\s]/g, '')
                .replace(/\./g, '')
                .replace(',', '.');

              const num = parseFloat(normalized);
              if (isNaN(num)) return null;

              return parseFloat(num.toFixed(2));
            }"
          />
        </template>
      </el-table-column>
    </el-table>

    <div class="text-end">
      <el-button class="mt-3" type="secondary" @click="handleSaveData(false)">
        {{ $t('components.mesh-loader.cancel') }}
      </el-button>
      <el-button class="mt-3" type="primary" @click="handleSaveData(true)">
        {{ $t('components.mesh-loader.save') }}
      </el-button>
    </div>
  </el-dialog>

  <!-- Form builder area  -->
  <div id="formbuilder-dialog" class="modal fade" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
      <div id="info-content" class="modal-content">
        <div id="info-body" class="modal-body p-0">
          <iframe src="/formbuilder/index.html" style="width: 100%; height: 100vh; border: none"></iframe>
        </div>
      </div>
    </div>
  </div>
  <!-- Form builder area end -->
</template>

<script lang="ts">
import { Vue, Component, Prop, Watch } from 'vue-facing-decorator';
import { ElForm, ElMessage, ElMessageBox } from 'element-plus';
import { UploadFile, UploadStatus } from 'element-plus/es/components/upload/src/upload';
import draggable from 'vuedraggable';
import * as THREE from 'three';
import { Modal } from 'bootstrap';
import { Buffer } from 'buffer'; // Impor Buffer polyfill
import { cloneDeep } from '@apollo/client/utilities';

import { ObjModel, StlModel } from '@/utils/three/importExport';
import MeshEditor from '@/components/three/scenes/MeshEditor.vue';
import { MeshTreeData } from '@/types/ui/MeshTreeData';
import {
  FileType3D,
  FileTypeImage,
  getFileType,
  getImageFileType,
  getVideoFileType,
  isValidFileType,
  isValidImageFileType,
  isValidVideoFileType,
  isValidFileSize,
  ProductType,
  TemplateUploadImageType,
  UploadCategory
} from '@/types/enum/upload';
import { UploadProgress } from '@/types/enum/workflow';
import { ModifyType, OrientationAxis } from '@/types/enum/three';
import { EditorModeState } from '@/types/enum/editor';
import PreviewRenderer from '@/components/three/scenes/PreviewRenderer.vue';
import PreviewRendererImg from '@/components/features/previewRenderer/PreviewRendererImg.vue';
import PreviewRendererVideo from '@/components/features/previewRenderer/PreviewRendererVideo.vue';
import * as TemplateService from '@/services/api/templateService';
import { MeshExportData } from '@/services/api/modelService';
import { DefaultUndoRedo } from '@/types/ui/HistoryList';
import {
  base64ToFile,
  deleteFileFromAzure,
  fileContentToBase64,
  generateVideoThumbnail,
  ProductVideoFiles,
  uploadToAzure,
} from '@/utils/file';
import { FileData } from '@/types/enum/file';
import { GetAllDistinctProductTypes } from '@/services/api/productService';
import Workflow from '@/components/workflow/Workflow.vue';
import { WorkflowModel } from '@/types/ui/WorkflowModel';
import UploadAssetsModal from '@/components/modals/UploadAssetsModal.vue';
import ImageUploadList from '@/components/features/uploadList/ImageUploadList.vue';
import ObjectUploadList from '@/components/features/uploadList/ObjectUploadList.vue';
import i18n from '@/i18n';
import { LocalColorType } from '@/types/constants/colors';
import { SupportedValues, SupportedValuesTextures } from '@/types/api/Utility/SupportedValues';
import ImageUploadListV2 from '@/components/features/uploadList/ImageUploadListV2.vue';
import { GetAllColors } from '@/services/api/colorService';
import { safeT } from '@/utils/text';
import { BasePriceDto, BodyPartDto, BodyPartType } from '@/types/api/Model/ProductUpsertRequest';
import { DomainPackagesOptions } from '@/views/template/TemplateUpload.vue';
import MultiCheckboxSelect from '@/components/ui-elements/MultiCheckboxSelect.vue';
import StepLineIndicator from '@/components/ui-elements/StepLineIndicator.vue';
import { getAllAvailableCountries } from '@/services/api/userService';

// Set Buffer as global for the browser environment
// eslint-disable-next-line @typescript-eslint/no-explicit-any
(window as any).Buffer = Buffer;

interface UploadData {
  name: string;
  url: string;
  uid: number;
  status?: UploadStatus;
}

export interface LoadingData {
  referenceCategory: UploadCategory;
  referenceId: string;
  category: UploadCategory;
  productType: ProductType;
  productTypeId: number;
  productTypeAttributeId: number | null;
  title: string;
  description: string;
  basePrices: BasePriceDto[];
  fileType: FileType3D;
  url: string;
  base64: string;
  packageId: number;
  packageIds: number[];
  bodyPart: BodyPartDto;
  meshSizes: MeshSizesType[];
}

interface ResultData {
  category: UploadCategory;
  title: string;
  mesh: THREE.Object3D;
  bones: THREE.Bone[];
  referenceId: string;
}

export type SelectedEngravingType = {
  fileId: number;
  thumbnailId: number | null
}

export type SelectedTextureType = {
  fileId: number;
  thumbnailId: number | null
}

export type MeshTreeDataWithUid = MeshTreeData & { uid?: number };

export interface UserFeedbackType {
  packageShowValidateError: boolean,
  meshShowValidateError: boolean,
  imageShowValidateError: boolean,
}

export interface UserFeedbackFieldsType {
  key: string;
  label: string;
}

export type MeshVectorType = {
  width: number;
  height: number;
  depth: number
}
export interface MeshSizesType {
  uuid: string;
  vector: MeshVectorType
}

@Component({
  components: {
    PreviewRenderer,
    MeshEditor,
    ObjModel,
    StlModel,
    draggable,
    PreviewRendererImg,
    PreviewRendererVideo,
    Workflow,
    UploadAssetsModal,
    ImageUploadList,
    ImageUploadListV2,
    ObjectUploadList,
    MultiCheckboxSelect,
    StepLineIndicator,
  },
  emits: ['update:uploadProgress', 'productTypeIdUpdated', 'selectedEngravingitems'],
})
/* eslint-disable @typescript-eslint/no-explicit-any*/
@Component
export default class MeshLoader extends Vue implements DefaultUndoRedo {
  @Prop({ default: UploadProgress.Select }) uploadProgress!: UploadProgress;
  @Prop({ default: null }) templateId!: number | null;
  @Prop({ default: 0 }) activeStep!: number;
  @Prop({ default: false }) canSelect!: boolean;
  @Prop({ default: false }) canTakeSnapshot!: boolean;
  @Prop({ default: false }) canToggleOpacity!: boolean;
  @Prop({ default: 'other' }) directoryPath!: string;
  @Prop({ default: false }) isProductConfig!: boolean;
  @Prop() workflowModel!: WorkflowModel<any>;
  @Prop({ default: false }) fullscreenLoading!: boolean;
  @Prop({ default: [] }) meshEngravings!: SupportedValues[];
  @Prop({ default: [] }) meshTextures!: SupportedValuesTextures[];
  @Prop({ default: false }) meshEngravingsLoading!: boolean;
  @Prop({ default: false }) meshTexturesLoading!: boolean;
  @Prop({ default: [] }) domainPackages!: DomainPackagesOptions[];
  selected = -1;
  TemplateUploadImageType = TemplateUploadImageType;

  // note: state for mesh 3d file (its for payload ModelService.uploadNewProduct).
  selectedInput: MeshTreeData = new MeshTreeData(null, this);
  // note: state for controlled el upload mesh 3d, keeping ui when clicking prev step
  meshFiles: FileData[] = [];

  // note: state for product image thumbnails refers to selected input format. Separate it from selectedInput state since it needs to be multiple  (it's for payload ModelService.uploadNewProduct).
  selectedProductImages: MeshTreeDataWithUid[] = [];
  // note: state for controlled el upload product image, keeping ui when clicking prev step
  productImageFiles: FileData[] = [];
  productVideoFiles: ProductVideoFiles[] = [];

  // For Engraving Files
  // note: state for product image thumbnails refers to selected input format. Separate it from selectedInput state since it needs to be multiple  (it's for payload ModelService.uploadNewProduct).
  selectedEngravingImagesLR: MeshTreeDataWithUid[] = [];
  // note: state for controlled el upload product image, keeping ui when clicking prev step
  engravingImageFilesLR: FileData[] = [];
  selectedEngravingImagesHR: MeshTreeDataWithUid[] = [];
  engravingImageFilesHR: FileData[] = [];

  // For Texture Files
  selectedTextureImagesLR: MeshTreeDataWithUid[] = [];
  textureImageFilesLR: FileData[] = [];
  selectedTextureImagesHR: MeshTreeDataWithUid[] = [];
  textureImageFilesHR: FileData[] = [];

  meshColors: LocalColorType[] = [] 
  selectedColors: LocalColorType[] = [];
  selectedEngraving: SelectedEngravingType[] = []
  selectedTextures: SelectedTextureType[] = []
  
  UploadProgress = UploadProgress;
  ModifyType = ModifyType;

  isFetchingProductTypeList = false;
  isFetchingCountries = false;
  productTypeList: { name: string; productTypeId: number }[] = [];
  productTypeAttributes: { productTypeAttributeId: number, productTypeAttributeName: string, productTypeId: number }[] = [];
  filteredProductTypeAttributes: { productTypeAttributeId: number, productTypeAttributeName: string, productTypeId: number }[] = [];
  countryList: { countryId: number; name: string; countryCode: string }[] = [];
  dialogVisible = false;

  loadingData: LoadingData = {
    referenceCategory: UploadCategory.ReferenceDummy,
    referenceId: '',
    category: UploadCategory.Product,
    productType: ProductType.fence, // Add this line
    productTypeId: 3,
    productTypeAttributeId: null,
    title: '',
    description: '',
    basePrices: [],
    fileType: FileType3D.NONE,
    url: '',
    base64: '',
    packageId: 1,
    packageIds: [],
    meshSizes: [],
    bodyPart: {
      name: 'Test',
      bodyPartType: BodyPartType.BodyPart,
    },
  };

  boneData: THREE.Bone[] = [];
  activeBoneIndex = 0;
  boneKey = 0;

  activeEditorMode: EditorModeState = EditorModeState.readonly;

  referenceData: MeshExportData[] = [];

  UploadCategory = UploadCategory;
  ProductType = ProductType;
  FileType = FileType3D;
  previousUploadProgress = UploadProgress.Select;
  OrientationAxis = OrientationAxis;
  getFileType = getFileType;
  getImageFileType = getImageFileType;
  getVideoFileType = getVideoFileType;
  showFormBuilder = false;
  private formbuilderDialog: any = null;
  private designFilesDialog: any = null;
  uploadVideoLoading = false;
  private uploadAssetsDialog: Modal | null = null;
  defaultAssetModalTab = 'product'
  private productConfigButtonText = i18n.global.t('confirm.formBuilder.buttonCreateNew');
  isSidemenu = true;
  currentStep = 0;
  steps = [
    i18n.global.t('views.default.indicatorLineLabel.productInformation'),
    i18n.global.t('views.default.indicatorLineLabel.uploadDesignAndTexture'),
  ];
  maxFileSizeMB = 1;
  safeT = safeT;

  // Add required field message in bottom element 
  userFeedback: UserFeedbackType = {
    packageShowValidateError: false,
    meshShowValidateError: false,
    imageShowValidateError: false,
  }

  // Add required field message in button next when user hover. 
  userFeedbackFields: UserFeedbackFieldsType[] = [
    { key: 'packageIds', label: i18n.global.t('components.mesh-loader.userFeedbackButtonNext.packageIds') },
    { key: 'title', label: i18n.global.t('components.mesh-loader.userFeedbackButtonNext.title') },
    { key: 'description', label: i18n.global.t('components.mesh-loader.userFeedbackButtonNext.description') },
    { key: 'meshFiles', label: i18n.global.t('components.mesh-loader.userFeedbackButtonNext.meshFiles') },
    { key: 'productImageFiles', label: i18n.global.t('components.mesh-loader.userFeedbackButtonNext.productImageFiles') },
  ]

  mounted(): void {
    this.uploadAssetsDialog = new Modal('#upload-assets-dialog', {});
    if (this.templateId) {
      TemplateService.getMeshData(this.templateId).then((result) => (this.referenceData = result));
    }

    this.isFetchingProductTypeList = true;
    GetAllDistinctProductTypes()
      .then((res) => {
        if (res.allDistinctProductTypes) {
          const productTypeList = res.allDistinctProductTypes.map((p: { name: any; productTypeId: any; }) => ({name:p.name, productTypeId:p.productTypeId}));
          this.productTypeList = productTypeList;
          const productTypeAttributes = res.allDistinctProductTypes.flatMap((productType: any) => {
            return productType.productTypeAttributes.map((attribute: any) => ({
              productTypeAttributeId: attribute.productTypeAttributeId,
              productTypeAttributeName: attribute.productTypeAttributeName,
              productTypeId: productType.productTypeId, 
            }));
          });
          this.productTypeAttributes = productTypeAttributes;
        }
        this.isFetchingProductTypeList = false;
      })
      .catch((err) => {
        this.isFetchingProductTypeList = false;
        console.error('[ERROR GET PRODUCT TYPES]: ', err);
      });

    GetAllColors().then((colors)=>{
      this.meshColors = colors
    })

    this.isFetchingCountries = true;
    getAllAvailableCountries().then((countries) => {
      const filteredCountries = [...countries].filter(c=> ['DE', 'AT'].includes(c.countryCode));
      this.countryList = filteredCountries;
      this.loadingData.basePrices = filteredCountries.map((country) => ({
        country: country.countryCode,
        price: 0,
      }));
      this.isFetchingCountries = false;
    }).catch((err) => {
      this.isFetchingCountries = false;
      console.error('[ERROR GET COUNTRIES]: ', err);
    });

    this.addBone((this as any).$t('components.mesh-loader.pivotBone'));
    this.$nextTick(() => {
      this.activeBoneIndex = 0;
    });

    const modalDialogOptions = {};
    this.formbuilderDialog = new Modal('#formbuilder-dialog', modalDialogOptions);

    const fields = localStorage.getItem('fields');
    this.productConfigButtonText = fields 
      ? i18n.global.t('confirm.formBuilder.buttonEditConfig')
      : i18n.global.t('confirm.formBuilder.buttonCreateNew');

    window.addEventListener(
      'message',
      (e) => {
        if (e.data === 'closeModal') {
          this.formbuilderDialog.hide();
        }
      },
      false
    );
  }
  
  get missingFields(): string {
    // filter & validate requred fields 
    const fields =  this.userFeedbackFields.filter(item => {
      switch (item.key) {
        case 'packageIds': return this.loadingData.packageIds.length === 0;
        case 'title': return this.loadingData.title.trim().length === 0;
        case 'description': return this.loadingData.description.trim().length === 0;
        case 'meshFiles': return this.meshFiles.length === 0;
        case 'productImageFiles': return this.productImageFiles.length === 0;
        default: return false;
      }
    });

    // get first field message 
    return fields.length > 0 ? fields[0].label : '';
  } 

  // Add a mesh size record to the loadingData.meshSizes array
  handleGetMeshSizes(value: MeshSizesType): void {
    if (!value) return; // If no value is provided, exit early
    // Validate if mesh already exists 
    const exists = this.loadingData.meshSizes.some(mesh => mesh.uuid === value.uuid);

    if (exists) {
      console.warn(`Mesh with UUID "${value.uuid}" already exists.`);
    }

    const { meshSizes } = this.loadingData; // Get the current list of mesh sizes
    this.loadingData.meshSizes = [...meshSizes, value]; // Append the new value to the list
  }

  handleRemoveMeshSizes(uuid: string): void {
    if(!uuid) return; //If no UUID is provided, exit early
    const initialLength = this.loadingData.meshSizes.length;

    // if uuid not found! 
    if (this.loadingData.meshSizes.length === initialLength) {
      console.warn(`Mesh with UUID "${uuid}" not found.`);
    }

    // Keep only meshes whose UUID does not match the given one
    this.loadingData.meshSizes = this.loadingData.meshSizes.filter(mesh => mesh.uuid !== uuid);
  }

  handleDomainPackagesChange(selected: number[]) {
    this.loadingData.packageIds = selected;
  }
  
  async handleMultipleRemove(selectedUids: number[]) {
    if (selectedUids.length === 0) return;

    const meshes = [...this.selectedInput.treeData]; 

    for (const mesh of meshes) {
      if (selectedUids.includes(Number(mesh.name))) {
        await this.selectedInput.removeItem(mesh);
      }
    }

    this.meshFiles = this.meshFiles.filter(
      ({ uid }) => !selectedUids.includes(uid)
    );

     // ✅ reset selection
    if (selectedUids.includes(this.selected)) {
      this.handleSelect(null);
    }

    this.userFeedback.meshShowValidateError = this.meshFiles.length <= 1;
  }

  handleUploadAssetClick({
  event,
  tab = 'product'
  }: {
    event: MouseEvent;
    tab: string;
  }) {
    const target = event.target as Element;
    const isTrashIcon = target.closest('.el-upload-list__item-delete');
    if (!isTrashIcon) {
      this.defaultAssetModalTab = tab;
      this.uploadAssetsDialog?.show();
    }
  }

  resetFormBuilderState() {
    const formBuilderIframe = document.querySelector('#formbuilder-dialog iframe') as HTMLIFrameElement | null;
    if (formBuilderIframe) {
      formBuilderIframe.contentWindow?.postMessage('RESET_STATE', '*');
    }
  }

  updateProductConfigButtonText(value: boolean): void {
    if (!value) this.resetFormBuilderState();
    this.productConfigButtonText = value 
      ? i18n.global.t('confirm.formBuilder.buttonEditConfig')
      : i18n.global.t('confirm.formBuilder.buttonCreateNew');
  }

  get categoryReferences(): MeshExportData[] {
    const references = this.referenceData.filter((item) => item.category === this.loadingData.referenceCategory);
    this.loadingData.referenceId = '';
    if (references.length > 0) this.loadingData.referenceId = references[0].uniqueKey;
    return references;
  }

  getResult(): ResultData | null {
    if (this.selectedInput.treeData.length > 0) {
      const treeData = this.selectedInput.treeData[0];
      return {
        category: this.loadingData.category,
        title: this.loadingData.title,
        mesh: treeData.mesh,
        bones: treeData.bones,
        referenceId: this.loadingData.referenceId,
      };
    }
    return null;
  }

  updateFilename(files: MeshTreeDataWithUid[], stateFiles: any[]): void {
    files.forEach(file => {
      const stateFile = stateFiles.find((f: { uid: any }) => f.uid === file.uid);
      if (!stateFile) return;
      const newName = stateFile.name;
      const fileExtension = stateFile?.raw?.type?.split?.('/')[1] ?? '';
      const hasExtension = newName.includes('.');
      file.thumbnail = hasExtension
        ? `${newName.split('.')[0]}.${fileExtension}`
        : `${newName}.${fileExtension}`;
    });
  }

  get isProductCategory(): boolean {
    return this.loadingData.category === UploadCategory.Product;
  }

  get isProductType(): boolean {
    return this.loadingData.productType !== null;
  }

  @Watch('templateId', { immediate: true })
  onTemplateIdChanged(): void {
    this.selectedInput.modelId = this.templateId;
    this.selectedInput.historyList.modelId = this.templateId;
    this.selectedInput.historyList.defaultUndoRedo = this;
  }

  @Watch('selectedInput.lastUpdateVisibility')
  async onSelectedInputVisibilityChanged(): Promise<void> {
    if (this.activeEditorMode === EditorModeState.bone) {
      if (this.selectedInput && this.selectedInput.treeData.length > 0) {
        this.activeBoneIndex = this.selectedInput.treeData[0].activeBoneIndex;
      }
    }
  }

  @Watch('loadingData.referenceId', { immediate: true })
  onReferenceIdChanged(): void {
    if (this.templateId && this.loadingData.referenceId) {
      const referenceItem = this.referenceData.find((item) => item.uniqueKey === this.loadingData.referenceId);
      if (referenceItem) {
        this.boneData.length = 0;
        for (const boneData of referenceItem.bones) {
          const bone = this.addBone(boneData.name);
          bone.position.copy(boneData.position.clone());
        }
      }
    }
  }

  @Watch('domainPackages', {immediate: true}) 
  onDomainPackagesChanges(newValue: DomainPackagesOptions[], oldValue: DomainPackagesOptions[]) {
    if (newValue && newValue.length === 1) {
      this.loadingData.packageIds = [newValue[0]?.value];
    }
  }  

  @Watch('loadingData.productTypeId', { immediate: true })
  onProductTypeIdChanged(newValue: number | null): void {
    if (!newValue) return;
    this.$emit('productTypeIdUpdated', newValue);
  }

  @Watch('meshFiles', { immediate: true, deep: true })
  onMeshFilesChanged(newValue: FileData[], oldValue: FileData[]): void {
    if (newValue && newValue?.length > 0) {
      this.userFeedback.meshShowValidateError = false;
    }
  }

  @Watch('productImageFiles', { immediate: true, deep: true })
  onProductImageFilesChanged(newValue: FileData[], oldValue: FileData[]): void {
    if (newValue && newValue?.length > 0) {
      this.userFeedback.imageShowValidateError = false;
    }
  }

  @Watch('loadingData.packageIds', {immediate: true}) 
  onPacakgeIdsChanges(newValue: number[], oldValue: number[]) {
    if (oldValue?.length === 1 && this.loadingData.packageIds?.length === 0) {
      this.userFeedback.packageShowValidateError = true;
    }
    if (newValue?.length > 0) {
      this.userFeedback.packageShowValidateError = false;
    }
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  async dragDone(event: any): Promise<void> {
    this.boneKey += 1;
    if (this.activeBoneIndex === event.oldIndex) {
      this.activeBoneIndex = event.newIndex;
    } else if (this.activeBoneIndex < event.oldIndex && this.activeBoneIndex >= event.newIndex) {
      this.activeBoneIndex++;
    } else if (this.activeBoneIndex > event.oldIndex && this.activeBoneIndex <= event.newIndex) {
      this.activeBoneIndex--;
    }
    this.selectedInput.updateVisibility();
  }

  @Watch('activeBoneIndex')
  onActiveBoneIndexChanged(): void {
    if (this.selectedInput && this.selectedInput.treeData.length > 0) {
      this.selectedInput.treeData[0].activeBoneIndex = this.activeBoneIndex;
      this.selectedInput.updateVisibility();
    }
  }

  getSelectionSize(): THREE.Vector3 {
    const meshEditor: MeshEditor = this.$refs.meshEditor as MeshEditor;
    if (meshEditor) {
      return meshEditor.getSelectionSize();
    }
    return new THREE.Vector3(10, 10, 10);
  }

  selectionChanged(target: THREE.Object3D | null): void {
    if (target && this.boneData.length <= 1) {
      this.addBone((this as any).$t('components.mesh-loader.secondBone'));
    }
  }

  addBone(name: string | null = null): THREE.Bone {
    let defaultBoneDistance = this.getSelectionSize().y;
    if (!defaultBoneDistance) defaultBoneDistance = 100;
    const bone = new THREE.Bone();
    bone.name = name ? name : (this.boneData.length + 1).toString();
    if (this.boneData.length === 0) {
      bone.position.set(0, 0, 0);
    } else {
      const to = this.boneData[this.boneData.length - 1].position.clone();
      const from = this.boneData.length === 1 ? new THREE.Vector3(0, -1, 0) : this.boneData[this.boneData.length - 2].position.clone();
      const direction = to.clone().sub(from).normalize().setLength(defaultBoneDistance);
      bone.position.copy(to.clone().add(direction));
    }
    this.boneData.push(bone);
    this.selectedInput.updateVisibility();
    this.$nextTick(() => {
      this.activeBoneIndex = this.boneData.length - 1;
    });
    return bone;
  }

  removeBone(index: number): void {
    ElMessageBox.confirm((this as any).$t('confirm.delete.message'), (this as any).$t('confirm.delete.title'), {
      confirmButtonText: (this as any).$t('confirm.delete.ok'),
      cancelButtonText: (this as any).$t('confirm.delete.cancel'),
      type: 'warning',
    }).then(() => {
      this.boneData.splice(index, 1);
      this.selectedInput.updateVisibility();
    });
  }

  isFileType(filename: string, filetype: FileType3D): boolean {
    return getFileType(filename) === filetype;
  }

  @Watch('uploadProgress', { immediate: true })
  onUploadProgressChanged(newValue: string): void {
    if (this.previousUploadProgress === UploadProgress.Select && this.uploadProgress !== this.previousUploadProgress) {
      this.previousUploadProgress = this.uploadProgress;
      const dataForm = this.$refs.dataForm as typeof ElForm;
      dataForm?.validate(async (valid: any) => {
        if (!valid) {
          this.$emit('update:uploadProgress', UploadProgress.Select);
          this.previousUploadProgress = UploadProgress.Select;
        }
      });
    }

    switch (this.uploadProgress) {
      case UploadProgress.Select:
        this.activeEditorMode = EditorModeState.readonly;
        break;
      case UploadProgress.Orientation:
        this.activeEditorMode = EditorModeState.orientation;
        break;
      case UploadProgress.Pivot:
        this.activeEditorMode = EditorModeState.bone;
        break;
    }

    this.isSidemenu = newValue !== UploadProgress.Orientation
  }

  takeSnapshot(): void {
    const meshEditor: any = this.$refs.meshEditor;
    const img = new Image();

    if (meshEditor.troisRenderer.scene && meshEditor.troisRenderer.camera) {
      meshEditor.troisRenderer.three.renderer.render(meshEditor.troisRenderer.scene, meshEditor.troisRenderer.camera);
    }

    img.src = meshEditor.troisRenderer.three.renderer.domElement.toDataURL();

    meshEditor.troisRenderer.three.renderer.clear();

    for (const item of this.selectedInput.treeData) {
      if (item.isSelected) {
        item.thumbnailUrl = img.src;
        item.thumbnail = item.name;
        item.thumbnailFiletype = FileTypeImage.JPG;
      }
    }
  }

  getNewMeshData(res: { file: { name: string | null; uid: number | undefined; }; }, encodedString: string | null){
    const newMeshData: MeshTreeDataWithUid = new MeshTreeData(null, this);
    newMeshData.thumbnail = res.file.name;
    newMeshData.thumbnailFiletype = getImageFileType(res.file.name!);
    newMeshData.thumbnailUrl = encodedString;
    newMeshData.uid = res.file.uid;
    return newMeshData
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  async uploadFile(res: any, imageType: TemplateUploadImageType): Promise<boolean> {
    if (imageType === TemplateUploadImageType.object3D) {
      const url = URL.createObjectURL(res.file);
      const data = { name: res.file.name, url: url, uid: res.file.uid };
      await this.addMesh(data);
      await this.handleSelect(data);
    }
    if (imageType === TemplateUploadImageType.product) {
      fileContentToBase64(res.file, (encodedString) => {
        this.selectedInput.thumbnail = res.file.name;
        this.selectedInput.thumbnailFiletype = getImageFileType(res.file.name)
        this.selectedInput.thumbnailUrl = encodedString
        const newMeshData = this.getNewMeshData(res, encodedString)
        this.selectedProductImages = [...cloneDeep(this.selectedProductImages), newMeshData];
      });
    }
    if (imageType === TemplateUploadImageType.engravingLR) {
      fileContentToBase64(res.file, (encodedStringLR) => {
        const newMeshDataLR = this.getNewMeshData(res, encodedStringLR)
        this.selectedEngravingImagesLR = [...cloneDeep(this.selectedEngravingImagesLR), newMeshDataLR];
      });
    }
    if (imageType === TemplateUploadImageType.engravingHR) {
      fileContentToBase64(res.file, (encodedStringHR) => {
        const newMeshDataHR = this.getNewMeshData(res, encodedStringHR)
        this.selectedEngravingImagesHR = [...cloneDeep(this.selectedEngravingImagesHR), newMeshDataHR];
      });
    }
    if (imageType === TemplateUploadImageType.textureLR) {
      fileContentToBase64(res.file, (encodedString) => {
        const newMeshData = this.getNewMeshData(res, encodedString)
        this.selectedTextureImagesLR = [...cloneDeep(this.selectedTextureImagesLR), newMeshData];
      });
    }
    if (imageType === TemplateUploadImageType.textureHR) {
      fileContentToBase64(res.file, (encodedString) => {
        const newMeshData = this.getNewMeshData(res, encodedString)
        this.selectedTextureImagesHR = [...cloneDeep(this.selectedTextureImagesHR), newMeshData];
      });
    }
    if (imageType === TemplateUploadImageType.video) {
      this.uploadVideoFileToAzure(res);
    }
    return true;
  }

  async uploadVideoFileToAzure(res: any): Promise<boolean> {
    this.uploadVideoLoading = true;

    // Get video file
    const videoFile = res.file;
    const videoDirectoryPath = `${this.directoryPath}/media/videos`;

    // Generate video thumbnail file
    const videoThumbnailFile = await generateVideoThumbnail(videoFile);
    const videoThumbnailDirectoryPath = `${this.directoryPath}/media/images`;

    // validation: If there is no videoFile or videoThumbnailFile,
    // then do not proceed to the next step
    if (!videoFile || !videoThumbnailFile) return false;

    try {
      // Upload video
      const videoUrl = await uploadToAzure({
        file: videoFile,
        direcatoryPath: videoDirectoryPath,
      });
      // Upload thumbnail
      const videoThumbnailUrl = await uploadToAzure({
        file: videoThumbnailFile,
        direcatoryPath: videoThumbnailDirectoryPath,
      });

      // update state video & thumbnail
      await this.setVideoFile(videoFile, videoUrl);
      await this.setVideoThumbnailFile(videoThumbnailFile, videoThumbnailUrl);
      await this.setProductVideoFiles(videoFile);

      alert('Upload successful!');
      this.uploadVideoLoading = false;
      return true;
    } catch (error) {
      console.error('Error uploading files:', error);
      alert('Upload failed. Please try again.');
      this.uploadVideoLoading = false;
      return false;
    }
  }

  async setProductVideoFiles(videoFile: FileData): Promise<boolean> {
    if (!videoFile) return false;
    return true;
  }

  async setVideoFile(file: File, videoUrl: string): Promise<boolean> {
    if (!file || !videoUrl.length) return false;

    this.selectedInput.video = file.name;
    (this.selectedInput.videoFiletype = getVideoFileType(file.name));
    (this.selectedInput.videoUrl = videoUrl);
    return true;
  }

  async setVideoThumbnailFile(file: File, videoThumbnailUrl: string): Promise<boolean> {
    if (!file || !videoThumbnailUrl.length) return false;

    this.selectedInput.videoThumbnail = file.name;
    (this.selectedInput.videoThumbnailFiletype = getImageFileType(file.name));
    (this.selectedInput.videoThumbnailUrl = videoThumbnailUrl);
    return true;
  }

  handleRemove(file: UploadFile, imageType: TemplateUploadImageType): void {
    ElMessageBox.confirm(
      (this as any).$t('components.mesh-loader.deleteMessage'),
      'info',
      {
        confirmButtonText: (this as any).$t('components.mesh-loader.yes'),
        cancelButtonText: (this as any).$t('components.mesh-loader.no'),
        type: 'warning',
      }
    )
    .then(async (confirm) => {
      if (!confirm) return;

      switch (imageType) {
        case TemplateUploadImageType.object3D: {
          const item = this.selectedInput.treeData.find((x) => x.name === file.uid.toString());
          if (item) {
            this.selectedInput.removeItem(item);
            this.userFeedback.meshShowValidateError = this.meshFiles.length <= 1;
            this.handleRemoveMeshSizes(item.uuid);
          }
          await this.handleSelect(null);
          const newMeshFiles = cloneDeep(this.meshFiles).filter((f) => f.uid !== file?.uid);
          this.meshFiles = newMeshFiles;
          break;
        }

        case TemplateUploadImageType.product: {
          this.selectedInput.thumbnail = null;
          this.selectedInput.thumbnailUrl = null;
          this.selectedInput.thumbnailFiletype = null;
          
          this.userFeedback.imageShowValidateError = this.productImageFiles.length <= 1;
          
          const newImageFiles = cloneDeep(this.productImageFiles).filter((f) => f.uid !== file?.uid);
          this.productImageFiles = newImageFiles;

          const newSelectedInputs = cloneDeep(this.selectedProductImages).filter((f) => f.uid !== file.uid);
          this.selectedProductImages = newSelectedInputs;
          break;
        }

        case TemplateUploadImageType.engravingLR: {
          const newImageFiles = cloneDeep(this.engravingImageFilesLR).filter((f) => f.uid !== file?.uid);
          this.engravingImageFilesLR = newImageFiles;

          const newSelectedInputs = cloneDeep(this.selectedEngravingImagesLR).filter((f) => f.uid !== file.uid);
          this.selectedEngravingImagesLR = newSelectedInputs;
          break;
        }

        case TemplateUploadImageType.engravingHR: {
          const newImageFiles = cloneDeep(this.engravingImageFilesHR).filter((f) => f.uid !== file?.uid);
          this.engravingImageFilesHR = newImageFiles;

          const newSelectedInputs = cloneDeep(this.selectedEngravingImagesHR).filter((f) => f.uid !== file.uid);
          this.selectedEngravingImagesHR = newSelectedInputs;
          break;
        }

        case TemplateUploadImageType.textureLR: {
          const newImageFiles = cloneDeep(this.textureImageFilesLR).filter((f) => f.uid !== file?.uid);
          this.textureImageFilesLR = newImageFiles;

          const newSelectedInputs = cloneDeep(this.selectedTextureImagesLR).filter((f) => f.uid !== file.uid);
          this.selectedTextureImagesLR = newSelectedInputs;
          break;
        }

        case TemplateUploadImageType.textureHR: {
          const newImageFiles = cloneDeep(this.textureImageFilesHR).filter((f) => f.uid !== file?.uid);
          this.textureImageFilesHR = newImageFiles;

          const newSelectedInputs = cloneDeep(this.selectedTextureImagesLR).filter((f) => f.uid !== file.uid);
          this.selectedTextureImagesLR = newSelectedInputs;
          break;
        }

        case TemplateUploadImageType.video: {
          const uploadNewProductVideoFiles = this.productVideoFiles.filter(({ uid }) => uid !== file.uid);

          if (this.selectedInput?.videoUrl) await deleteFileFromAzure(this.selectedInput.videoUrl);
          if (this.selectedInput?.videoThumbnailUrl) await deleteFileFromAzure(this.selectedInput?.videoThumbnailUrl);

          this.productVideoFiles = uploadNewProductVideoFiles;
          this.selectedInput.video = null;
          this.selectedInput.videoUrl = null;
          this.selectedInput.videoFiletype = null;
          this.selectedInput.videoThumbnail = null;
          this.selectedInput.videoThumbnailUrl = null;
          this.selectedInput.videoThumbnailFiletype = null;
          break
        }
      }
    })
    .catch(() => {
      // cancellation, do nothing
    });
  }

  handleRemoveSelectedImage(files: UploadFile | UploadFile[], imageType: TemplateUploadImageType): void {
    const fileArray = Array.isArray(files) ? files : [files];
    
    if (fileArray.length === 0) return;
    
    const fileNames = fileArray.map(f => f.name).join(', ');
    const message = fileArray.length === 1 
      ? (this as any).$t('components.mesh-loader.deleteImageMessage')
      : (this as any).$t('components.mesh-loader.deleteAllImageMessage', {count: fileArray.length, fileNames: fileNames})

    ElMessageBox.confirm(
      message,
      'info',
      {
        confirmButtonText: (this as any).$t('components.mesh-loader.yes'),
        cancelButtonText: (this as any).$t('components.mesh-loader.no'),
        type: 'warning',
      }
    )
    .then(async (confirm) => {
      if (!confirm) return;

      for (const file of fileArray) {        
        switch (imageType) {
          case TemplateUploadImageType.product: {
            if (this.selectedInput.thumbnail === file.name) {
              this.selectedInput.thumbnail = null;
              this.selectedInput.thumbnailUrl = null;
              this.selectedInput.thumbnailFiletype = null;
            }
            
            this.selectedProductImages = this.selectedProductImages.filter((f) => {
              const data = f.uid !== file.uid;
              return data;
            });
            this.productImageFiles = this.productImageFiles.filter((f) => f.uid !== file.uid);
            break;
          }

          case TemplateUploadImageType.engravingHR: {
            this.selectedEngravingImagesHR = this.selectedEngravingImagesHR.filter((f) => {
              const data = f.uid !== file.uid;
              return data;
            });
            this.engravingImageFilesHR = this.engravingImageFilesHR.filter((f) => f.uid !== file.uid);
            break;
          }

          case TemplateUploadImageType.textureHR: {
            this.selectedTextureImagesHR = this.selectedTextureImagesHR.filter((f) => {
              const data = f.uid !== file.uid;
              return data;
            });
            this.textureImageFilesHR = this.textureImageFilesHR.filter((f) => f.uid !== file.uid);
            break;
          }
        }
      }

      if (imageType === TemplateUploadImageType.product) {
        this.userFeedback.imageShowValidateError = this.productImageFiles.length <= 1;
      }
    })
    .catch(() => {
      // cancellation, do nothing
    });
  }

  async addMesh(file: UploadData | null): Promise<void> {
    if (file) {
      const fileType = getFileType(file.name) as FileType3D;
      if (fileType !== FileType3D.NONE) {
        this.selected = file.uid;
        if (file.url) {
          const item = this.selectedInput.addImport(file.uid.toString(), file.name, file.url, '', '', null, true);
          item.bones = this.boneData;
          item.activeBoneIndex = this.activeBoneIndex;
          this.loadingData.url = file.url;
          this.loadingData.fileType = fileType;
        }
      }
    }
  }

  async handleSelect(file: UploadData | null): Promise<void> {
    if (file) {
      const fileType = getFileType(file.name) as FileType3D;
      if (fileType !== FileType3D.NONE) {
        this.selected = file.uid;
        for (const treeData of this.selectedInput.treeData) {
          if (treeData.name == this.selected.toString()) {
            treeData.isSelected = true;
          }
        }
      }
    } else {
      this.selected = -1;
    }
  }

  beforeUpload(file: any): boolean {
    if (isValidFileType(file.name)) {
      return true;
    }
    ElMessage.error((this as any).$t('components.mesh-loader.wrongType'));
    return false;
  }

  beforeImageUpload(file: any, resolve: (result: boolean) => void, imageType?: TemplateUploadImageType): void {
    
    if (!file) {
      resolve(false);
      return;
    }
    
    if (!isValidImageFileType(file.name)) {
      ElMessage.error((this as any).$t('components.mesh-loader.wrongType'));
      resolve(false);
      return;
    }
    
    if (!isValidFileSize(file.size, this.maxFileSizeMB)) {
      ElMessage.error((this as any).$t('components.mesh-loader.productImageValidateSize', {maxFileSize: this.maxFileSizeMB}))
      resolve(false);
      return;
    }

    if (imageType === TemplateUploadImageType.product && this.productImageFiles.length === 1) {
      ElMessage.error((this as any).$t('components.mesh-loader.productImageValidateLimit'))
      resolve(false);
      return;
    }
    
    resolve(true);
  }

  beforeVideoUpload(file: any): boolean {
    if (isValidVideoFileType(file.name)) {
      if (this.selectedInput.videoUrl == null) {
        return true;
      }
      ElMessage.error((this as any).$t('components.mesh-loader.onlyOneVideo'));
      return false;
    }
    ElMessage.error((this as any).$t('components.mesh-loader.wrongType'));
    return false;
  }

  logProductType(value: ProductType): void {
    const productTypeId = this.productTypeList.find(type=>type.name === value)?.productTypeId
    this.loadingData.productTypeId = productTypeId ?? 0
    this.filteredProductTypeAttributes = this.productTypeAttributes.filter(type=>type.productTypeId === productTypeId);
    if(this.filteredProductTypeAttributes.length === 0){
      this.loadingData.productTypeAttributeId = null;
    }
  }

  async defaultUndo(): Promise<void> {
    //
  }

  async defaultRedo(): Promise<void> {
    //
  }

  setShowFormBuilder(): void {
    this.formbuilderDialog.show();
  }

  toggleSidemenu() {
    this.isSidemenu = !this.isSidemenu;
    const sidemenu = document.getElementById('sidemenu');
    const workflowSection = document.getElementById('workflow-section');

    if (this.isSidemenu) {
      sidemenu?.classList.add('expanded');
      workflowSection?.classList.add('expanded');
    } else {
      sidemenu?.classList.remove('expanded');
      workflowSection?.classList.remove('expanded');
    }
  }

  goToNext() {
    this.currentStep++;
  }

  goToPrevious() {
    this.currentStep--;
  }

  setIndicatorStep(button: string) {
    if (button === 'previous') {
      return this.currentStep > 0
    } else {
      return this.currentStep < this.steps.length - 1
    }
  }

  handleSaveData(save: boolean) {
    console.log(this.loadingData.basePrices);
      this.dialogVisible = false; 
  }

  get validateNextStep(): boolean {
    switch (this.currentStep) {
      case 0:{
        return Boolean(
          this.loadingData?.title &&
          this.loadingData.description &&
          this.meshFiles.length &&
          this.productImageFiles.length
        )
      }
      case 1:{
        const isLengthEngravingSame = this.engravingImageFilesHR.length === this.engravingImageFilesLR.length
        const isLengthTextureSame = this.textureImageFilesHR.length === this.textureImageFilesLR.length
        return isLengthEngravingSame && isLengthTextureSame;
      }
      case 2:
        return true;
      default:
        return false;
    }
  }

  get selectMeshStepValid():boolean{
    const title = !!this.loadingData.title
    const description = !!this.loadingData.description
    const meshFiles = this.meshFiles.length > 0
    const productImageFiles = this.productImageFiles.length > 0
    const packageIds = this.loadingData.packageIds.length > 0
    // const productImageFilesValidate = this.isValidationProductImageSize
    // const engravingFilesValidate = this.engravingImageFilesHR.length === this.engravingImageFilesLR.length
    // const textureFilesValidate = this.textureImageFilesHR.length === this.textureImageFilesLR.length
    
    return title && 
      description && 
      meshFiles && 
      productImageFiles &&
      packageIds
      // productImageFilesValidate && 
      // engravingFilesValidate && 
      // textureFilesValidate
  }

  get selectedEngravingitems(): FileData[] {
    const selectedIds = this.selectedEngraving
      .map((item) => item.fileId)
      .filter((fileId) => fileId as number != null)

    const engravingList = this.meshEngravings
      .filter(item => selectedIds.includes(item?.fileId as number))
      .map(item => {
        if (!item.thumbnail) return null;
        const { fileId, type, name, content } = item.thumbnail;
        const normalizedType = type.startsWith('.') ? type : `.${type}`;
        const filename = name + normalizedType;
        const rawFile = base64ToFile(content, filename, 'image/png');
        const blobFile = URL.createObjectURL(rawFile);

        return {
          name: item.thumbnail.name,
          percentage: 100,
          status: 'success',
          size: rawFile.size,
          raw: rawFile,
          uid: fileId as number,
          url: blobFile as string,
          response: true
        } as FileData;

      })
      .filter(Boolean) as FileData[];

    return engravingList
  }

  get selectedTexturesitems(): FileData[] {
    const selectedIds = this.selectedTextures
    .map((item) => item.fileId)
    .filter((fileId) => fileId as number != null);

    const texturesList = this.meshTextures
      .filter(item => selectedIds.includes(item?.fileId as number))
      .map(item => {
        if (!item.thumbnail) return null;
        const { fileId, type, name, content } = item.thumbnail;
        const normalizedType = type.startsWith('.') ? type : `.${type}`;
        const filename = name + normalizedType;
        const rawFile = base64ToFile(content, filename, 'image/png')
        const blobFile = URL.createObjectURL(rawFile);

        return {
          name: item.thumbnail.name,
          percentage: 100,
          status: 'success',
          size: rawFile.size,
          raw: rawFile,
          uid: fileId as number,
          url: blobFile as string,
          response: true
        } as FileData;

      })
      .filter(Boolean) as FileData[];

    return texturesList
  }

}

</script>

<style lang="scss" scoped>
.el-scrollbar :deep(.el-scrollbar__view) {
  margin: 1rem;
}

.el-steps :deep(.el-steps--vertical) {
  height: unset;
}

.el-steps :deep(.el-step__head.is-process) {
  color: var(--el-color-primary);
  border-color: var(--el-color-primary);
}

.el-steps :deep(.el-step__head.is-finish .el-step__head.is-wait) {
  color: var(--el-text-color-primary);
  border-color: var(--el-text-color-primary);
}

.asideWithButton {
  position: relative;

  .scrollArea {
    height: 100%;
    padding-bottom: 4rem;
  }

  .addButton {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
  }
}

.big {
  margin-bottom: 0.5rem;
}

.upload-item {
  overflow: visible;
  width: 100%;
  height: 100%;
  border-radius: inherit;
}

.selected {
  border: var(--color-primary) 2px solid;
}

.bones {
  min-height: calc(100vh - 7.2rem);
}

.addButton {
  position: absolute;
  bottom: 40px;
  right: 10%;
}

.action {
  color: var(--color-primary);
}

.workflow-section.expanded {
  width: calc(100% - 7rem);
}
.workflow-section {
  position: absolute;
  bottom: 0;
  width: calc(100% - 32rem);
  z-index: 5 !important;
  transition: width 0.3s ease;
}
.sidemenu {
  flex: 0 0 auto;
  height: 100%;
  width: 0;
  background-color: #ffff;
  transition: width 0.3s ease;
  overflow-y: hidden;
  overflow-x: hidden;
  z-index: 2;
  box-shadow: 1px 0 10px #cccccc;
}
.sidemenu-header {
  text-align: center;
  margin-bottom: 1rem;
}
.sidemenu.expanded {
  position: relative;
  width: 25rem;

  .sidemenu-footer {
    position: absolute;
    display: flex;
    height: 11vh;
    width: 100%;
    bottom: 0;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    background-color: #ffffff;
    box-shadow: 0 -5px 8px #dedede;
    z-index: 1000;
  }
}
.collapse-btn {
  position: relative;
  align-self: center;
  height: fit-content;
  z-index: 2;
  background-color: #ffff;
  color: #1d1e19;
  border: none;
  margin: 0;
  padding: 0.5rem 0.3rem;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  box-shadow: 5px 0 4px #cccccc;
  transition: transform 0.3s ease;
}
.collapse-btn:hover {
  background-color: #f4f4f4;
}
.form-container {
  background: linear-gradient(180deg, #f0f0f0, #d6d6d6) !important;
}
.sidemenu-footer {
  display: none;
}

.workflow-button {
  background-color: var(--color-primary);
  color: var(--primary-text);
  border: none;
  height: 3rem;
  width: 7rem;
  padding: inherit;
  border-radius: 8px;
  cursor: pointer;
}
.workflow-button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.workflow-indicator {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
}

.workflow-indicator-line {
  height: 0.5rem;
  width: 4rem;
  background-color: #ccc;
  margin: 0 3px;
  transition: background-color 0.3s ease;
  border-radius: 5px 5px 5px 5px;
  cursor: pointer;
}
.workflow-indicator-line.active {
  background-color: var(--color-primary);
}
.step-view {
  position: relative;
  padding-left: 10% !important;
  padding-right: 10% !important;
  padding-bottom: 5rem !important;
  height: 100%;
}
.step-content {
  padding-bottom: 80px;
}
.title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 700;
  color: #1d1e19;
}
.btn-stepper {
  min-width: 100px;
}

.text-sm{
  font-size: 12px;
}

.color-gallery{
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;
  padding-bottom: 16px;
  align-items: stretch;
  gap: 8px;
  cursor: pointer;
  .color-item{
    line-height: normal;
    text-align: center;
    border: 1px solid #f1f1f1;
    box-shadow: 2px 2px 2px #f1f1f1;
    padding: 8px;
    border-radius: 4px;
    display: flex;
    cursor: pointer;
    flex-direction: column;
    gap: 6px;
    justify-content: flex-start;
    align-items: center;
    min-width: 100px !important;
    .color{
        width: 40px;
        height: 40px;
        border-radius: 50%;
        border: 1px solid #DDD;
    }
  }
}

.el-main {
  overflow: hidden;
}

.el-footer {
  display: flex;
  justify-content: center;
  align-items: center;
}

:deep(.el-steps) {
  width: 100%;
  flex: 1;
}

.sub-title {
  font-size: 12px;
  line-height: 16px;
  color: rgba(0, 0, 0, 0.67);
}
</style>

<style lang="scss">

.upload-list-dialog{
  .el-upload.is-disabled .el-upload-dragger,
  .el-upload.is-disabled{
    cursor: pointer !important;
  }
}
</style>
